// Webpack Imports
import * as bootstrap from 'bootstrap';
window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

	function delay(fn, ms = 500) {
		let timer = 0
		return function(...args) {
			clearTimeout(timer)
			timer = setTimeout(fn.bind(this, ...args), ms || 0)
		}
	}

	$(document.body).on('click', '.quantity-counter .increment', function() {
		
		// Enhances number input adding increment buttons
		let dir = $(this).attr('direction')
		let input = $(this).closest('.quantity-counter').find('input')[0]
		let value = input.value

		if(dir =='up')  {
			value++
		}

		if(dir =='down')  {
			if(value > 1) {
				value--
			}
		}

		input.value = value
		$(input).trigger('change')
	})

	let floatingCart = {
		refreshFragments(fragments){
			$.each(fragments, (key, value) =>  $(key).replaceWith(value) );
		},
		el: $('.floating-cart'),
		init(){
			$(document.body).on('click', '.floating-cart-close-button', () => this.close() )
			$(document.body).on('click', '.floating-cart-open-button', () => this.open() )
			$(document.body).on('click', '.floating-cart-toggle-button', () => this.toggle() )
			$(document.body).on('change', '.floating-cart .quantity-input', this.updateQuantity)
		},
		updateQuantity: delay( async(el) => {

			let $input = el.target
			let key = $input.getAttribute('cart-key')
			let quantity = $input.value
			floatingCart.busy()
			let res = await $.post('?wc-ajax=cart/update-quantity', {
				key, 
				quantity
			})
			floatingCart.refreshFragments(res.fragments)
			floatingCart.ready()
		}),
		toggle(){
			if( this.el.length == 0 ) {
				window.location = "/cart"
			}
			this.el.hasClass('open') ? this.close() : this.open()
		},
		ready() {
			this.el.removeClass('busy')
		},
		busy(){
			this.el.addClass('busy')
		},
		refresh( cb = () => {} ){
			this.busy()
			/**
				Take a CB fn that is fired once event concludes.
				Binds temporary fn to apply logic
			*/
			let fn = () => {
				$( document.body ).off( 'wc_fragments_refreshed', fn)	
				cb()
				this.ready()
			}

			$( document.body ).on( 'wc_fragments_refreshed', fn)
			$( document.body ).trigger( 'wc_fragment_refresh' )
		},
		open() {
			if( this.el.length == 0 ) {
				return;
			}
			this.el.addClass('open')
			$('body').addClass('noscroll');
		},
		_close(){
			this.el.removeClass('open');
			$('body').removeClass('noscroll');
		},
		close(delay = 0){
			setTimeout(() => this._close(), delay)
		}
	}
	floatingCart.init();

	$(document).on('submit','form.cart', function(e){
		e.preventDefault()
		submitForm( new FormData(e.target) )
	});

	let submitForm = async(data) => {
		
		$('form.cart').addClass('loading');

		$('form.cart .loading-container').attr('loading', true);

		data.append('action', 'woo-product-add-to-cart');

		let res = await $.ajax({
            type: 'POST',
            url: fweb.ajax_url,
			processData: false,
			contentType: false,
            data,
        });

		let response = JSON.parse(res)
		
		$('form.cart').removeClass('loading');

		$('form.cart .loading-container').attr('loading', false);

		if(response.valid) {
			floatingCart.open()
			floatingCart.refresh( () => floatingCart.close(2000) )
		}
	}

	let fauxVariations = () => {
		let bindEl = $el => {	

			let data = {
				get $value(){
					/**
						Value is the current value of the $select element
					*/
					return data.$select.value
				},
				get $select(){
					/**
						$Select is the target woo select this is bound to
					*/
					return document.querySelector(`select[data-attribute_name='attribute_${data.attribute_name}']`)
				},
				get attribute_name() {
					return $el.getAttribute('data-attribute_name')
				},
				get attribute_value(){
					return $el.getAttribute('data-attribute_value')
				},
				click(){
					$(data.$select)
						.val(data.attribute_value)
						.trigger('change')
				},
				validateIsAvailable(){
					let validValues = Array.from(data.$select.options)
						.map(e => {
							return e.value
						})
					if( !validValues.includes(data.attribute_value) ) {
						return $el.classList.add('disabled')
					}
					$el.classList.remove('disabled')
				},
				inputChange(){
					
					data.validateIsAvailable()
					let { 
						$value,
						attribute_value
					} = data

					data.setOff()

					if($value == '') return;
					if($value == attribute_value) data.setOn()
					
				},
				setOn(){
					$el.classList.add('active')
				},
				setOff() {
					$el.classList.remove('active')
				}
			}
			$el.addEventListener('click', data.click)
			$(data.$select).on('change', data.inputChange)
			/**
				firing to init it.
			*/
			data.inputChange()
			return data;
		}

		let variations = $('.faux-variation-button');

		let elements = variations.map((k, $el) => bindEl($el) )
		

		let revalidateOptions = () => {
			/**
				"Debouncing" so the input events have time to trigger before checking
			*/
			setTimeout(() =>  elements.map( (k, $el) => $el.validateIsAvailable() ), 1);
		}

		$('select[data-attribute_name]').each((k, e) => $(e).on('change', revalidateOptions ) )
		
	}

	fauxVariations();


	

	class DJEnquiry {
		constructor(options) {
			this.ajaxUrl = options.ajaxUrl;
			this.widgetSelector = options.widgetSelector;
			this.popupSelector = options.popupSelector || null; // e.g., '.open-enquiry-popup'
			this.init();
		}

		init() {
			const self = this;

			jQuery(document).on('click', '.add-to-enquiry', function (e) {
				e.preventDefault();
				const djId = jQuery(this).data('dj-id');
				self.addToEnquiry(djId);

				// Open popup via selector
				if (self.popupSelector) {
					jQuery(self.popupSelector).trigger('click');
				}
			});

			jQuery(document).on('click', '.remove-enquiry', function () {
				const djId = jQuery(this).closest('li').data('dj-id');
				self.removeFromEnquiry(djId);
			});

			// self.updateEnquiryWidget();
		}

		addToEnquiry(djId) {
			jQuery.post(this.ajaxUrl, {
				action: 'enquiry_add_dj',
				dj_id: djId
			}, () => {
				this.updateEnquiryWidget();
				// Open popup by dynamic button
				if (this.popupSelector) {
					this.openPopupViaTempButton(this.popupSelector);
				}
			});
		}

		removeFromEnquiry(djId) {
			jQuery.post(this.ajaxUrl, {
				action: 'enquiry_remove_dj',
				dj_id: djId
			}, () => {
				this.updateEnquiryWidget();
			});
		}

		updateEnquiryWidget() {
			jQuery.post(this.ajaxUrl, {
				action: 'get_enquiry_djs'
			}, (response) => {
				jQuery(this.widgetSelector).html(response.html);
			});
		}

		openPopupViaTempButton(popupSelector) {

			// Wait for Elementor to be ready
			if (typeof elementorProFrontend === 'undefined') {
				return;
			}

			// Only open if it's not already open
			const isOpen = jQuery('.elementor-popup-modal').is(':visible');
			if (isOpen) return;

			// Create and trigger temporary button
			const $btn = jQuery('<button>', {
				type: 'button',
				style: 'display: none;',
				id: popupSelector,
			});

			jQuery('body').append($btn);

			// Use native click to simulate user action (not .trigger('click'))
			$btn[0].click();

			setTimeout(() => $btn.remove(), 500); // delay cleanup slightly
		}
	}

	// Initialize on document ready
	// window.DJEnquirySystem = new DJEnquiry();
	window.DJEnquirySystem = new DJEnquiry({
		ajaxUrl: fweb.ajax_url,
		widgetSelector: '#enquiry-widget .enquiry-list',
		popupSelector: 'floating-enquiry-click' // Elementor popup ID
	});


	// Only target Elementor Nav Menus
	$('.elementor-nav-menu').each(function () {
		const $menu = $(this);

		// 1) Intercept arrow click as early as possible so Elementor doesn't also handle it.
		$menu.on('pointerdown', '.sub-arrow', function (e) {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
		});

		// 2) If the arrow is clicked (inside the <a>), prevent the <a> click from toggling too.
		$menu.on('click', '.menu-item-has-children > a', function (e) {
			if ($(e.target).closest('.sub-arrow').length) {
				e.preventDefault();
				e.stopPropagation();
				e.stopImmediatePropagation();
				return false;
			}
			// Otherwise allow normal navigation on link text
		});

		// 3) Only toggle the submenu for THIS exact level (not parents).
		$menu.on('click', '.sub-arrow', function (e) {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();

			const $li = $(this).closest('li.menu-item-has-children');
			const $submenu = $li.children('ul.sub-menu').first(); // only direct child submenu

			$li.toggleClass('submenu-open');

			// slideToggle ONLY this submenu (no parent touching)
			$submenu.stop(true, true).slideToggle(200);

			return false;
		});
	});

} )();

jQuery(function() { 
	jQuery.navigation.init();
});

jQuery(window).on('resize', (function() {
	return function(e) {
		jQuery.navigation.repositionDropdowns();
	};
})());

(function ( $ ) {
	$.navigation = {
		/**
		 * Initialize navigation.
		 */
		'init': function () {
			this.handleResponsiveDropdowns();
			this.handleTouchDropdowns();
			this.repositionDropdowns();
			this.activeParentLink();
		},

		/**
		 * Handles dropdowns on touch devices.
		 * @returns {boolean}
		 */
		'handleTouchDropdowns': function () {
			var windowWidth = window.innerWidth;
			if ( windowWidth < 991 ) {
				return false;
			}

			var self = this;
			$( '.caret-wrap' ).on( 'touchstart', function ( e ) {
				e.preventDefault();
				e.stopPropagation();
				var menuItem = $( this ).closest( 'li' );
				if ( $( menuItem ).hasClass( 'dropdown-submenu' ) ) {
					$( menuItem ).siblings().removeClass( 'open' ).find( 'dropdown-submenu' ).removeClass( 'open' );
					$( menuItem ).siblings().find( '.caret-open' ).removeClass( 'caret-open' );
				}
				if ( $( this ).closest( 'li' ).parent().is( '.nav' ) ) {
					self.clearDropdowns();
				}
				$( this ).toggleClass( 'caret-open' );
				$( this ).closest( '.dropdown' ).toggleClass( 'open' );
			} );
			return false;
		},

		'clearDropdowns': function () {
			$( '.dropdown.open' ).removeClass( 'open' );
			$( '.caret-wrap.caret-open' ).removeClass( 'caret-open' );
		},

		/**
		 * Handle the responsive menus under 769px.
		 */
		'handleResponsiveDropdowns': function () {
			var windowWidth = window.innerWidth;
			if ( windowWidth > 768 ) {
				return false;
			}
			$( '.navbar .dropdown > a .caret-wrap' ).on( 'click touchend',
				function ( event ) {
					var caret = $( this );
					event.preventDefault();
					event.stopPropagation();
					//Change caret wrap.
					$( caret ).toggleClass( 'caret-open' );
					//Open dropdown.
					$( caret ).parent().siblings().toggleClass( 'open' );
				}
			);
		},

		/**
		 * Add active parent links on navigation
		 */
		'activeParentLink': function () {
			$( '.navbar .dropdown > a' ).on('click',
				function () {
					//Do nothing if it's an empty hash.
					if ( $( this ).attr( 'href' ) === '#' ) {
						return false;
					}
					location.href = this.href;
					return false;
				}
			);
		},

		/**
		 * Reposition dropdowns if they are out of screen.
		 * @returns {boolean}
		 */
		'repositionDropdowns': function () {
			var windowWidth = window.innerWidth;
			//Do nothing on mobile.
			if ( windowWidth <= 768 ) {
				return false;
			}
			//Do nothing without dropdowns.
			var dropdowns = $( '.dropdown-menu' );
			if ( dropdowns.length === 0 ) {
				return false;
			}
			//Loop dropdowns and move them if needed.
			$.each( dropdowns, function ( key, dropdown ) {
				var submenu = $( dropdown );
				var bounding = submenu.offset().left;
				if ( /webkit.*mobile/i.test( navigator.userAgent ) ) {
					bounding -= window.scrollX;
				}
				var dropdownWidth = submenu.outerWidth();
				if ( bounding + dropdownWidth >= windowWidth ) {
					$( dropdown ).css( { 'right': '100%', 'left': 'auto' } );
				}
			} );
			return false;
		}
	};
} )( jQuery );

(function($){
    const DJPanel = {
        ajaxUrl: (window.fweb && fweb.ajax_url) || '/wp-admin/admin-ajax.php',
        $wrap: null,
        init() {
            // this.$wrap = $('#dj-badges-wrap');
            this.bind();
            this.refreshBadges();

			this.watchForPopups();
        },
        bind() {
            // Remove badge
            $(document).on('click', '.dj-badge-remove', (e) => {
                const id = parseInt($(e.currentTarget).closest('.dj-badge').data('dj-id'), 10);
                if (!id) return;
                $.post(this.ajaxUrl, { action: 'enquiry_remove_dj', dj_id: id }, (res) => {
                    this.refreshBadges();
                });
            });

            // Show GF form when CTA is clicked (or open another popup if you want)
			$(document).on('click', '#dj-send-enquiry', (e) => {
                // If your GF form is in the same popup, just reveal it:
                $('#dj-enquiry-form-wrap').removeClass('is-hidden');
				this.refreshBadges();

                // If your GF form lives in a *different* popup, open it here instead:
                // elementorProFrontend.modules.popup.showPopup({ id: YOUR_FORM_POPUP_ID });

                // Re-populate hidden field on the loaded form (optional, if not using GF filter):
                // this.fillHiddenFieldFromSession();
            });
        },
        refreshBadges() {
            $.post(this.ajaxUrl, { action: 'get_enquiry_badges' }, (res) => {
                if (res && res.success) {
					$('#dj-badges-wrap').html(res.data.html);
                } else {
                    $('#dj-badges-wrap').html('<em>Failed to load.</em>');
                }
            });

			// Update the original view
			window.DJEnquirySystem.updateEnquiryWidget();
        },
        // Optional: if you want to set hidden field value via JS rather than GF filter
        fillHiddenFieldFromSession() {
            $.post(this.ajaxUrl, { action: 'get_enquiry_badges' }, (res) => {
                // You’d really want a separate endpoint that returns IDs (not HTML).
                // Example (add one if needed) returns {ids:[...]} and then:
                // $('input[name="enquiry_djs"]').val(res.data.ids.join(','));
            });
        },
		watchForPopups() {
			$(document).on('elementor/popup/show', (evt, id) => {
				const $badgeWrap = $('#dj-badges-wrap');
				if ($badgeWrap.length) {
					this.refreshBadges();
				}
			});
		}
    };

    $(DJPanel.init.bind(DJPanel));

	// On AJAX confirmation, clear session (optional call) and refresh UI
	$(document).on('gform_confirmation_loaded', function(e, formId){
		if (formId !== 1) return;
		
		// Clear any badge containers currently in popups
		$('#dj-badges-wrap, #enquiry-widget .enquiry-list').html('');
		$('.dj-enquiry-panel .dj-enquiry-to').hide();
	});
})(jQuery);
